module.exports = "/packs/images/sprites/footer~58a8749d7f6e8bad98d8faeb118c7588.png";